module.exports = __webpack_public_path__ + "static/media/LockAccess.7004caa6.png";